export type TPlaceholderKeys =
  | 'winnersMobile'
  | 'winnersDesktop'
  | 'winnersPlaceholderMobile'
  | 'winnersPlaceholderDesktop'
  | 'marketingPlaceholderMobile'
  | 'marketingPlaceholderDesktop'
  | 'sideBannerPlaceholder'
  | 'promotionsPlaceholder'
  | 'bannerPlaceholderMobile'
  | 'bannerPlaceholderDesktop'
  | 'contentPostPlaceholder'
  | 'contentCardPlaceholder'
  | 'masonryPlaceholderOne'
  | 'masonryPlaceholderTwo'
  | 'categoryCardPlaceholder'
  | 'iconPlaceholder';

export type TStandardImageKeys =
  | 'positionGold'
  | 'positionSilver'
  | 'positionBronze'
  | 'hotGames'
  | 'mostPopular'
  | 'winnersIcon'
  | 'infoIcon'
  | 'celebrationIcon'
  | 'mostLiked'
  | 'notFoundLight'
  | 'notFoundDark'
  | 'huawei'
  | 'android'
  | 'apple'
  | 'googlePlay'
  | 'exclusive'
  | 'mpumalangaEconomicRegulator'
  | 'freeplayOverlay'
  | 'merLicense'
  | 'dailyWheelPopUp'
  | 'jpcRewardsCityLogo'
  | 'myBigWinsShareImage'
  | 'progressiveJackpotsPlayNowCta'
  | 'progressiveJackpotsMoreInfoCta'
  | 'progressiveJackpotsInGameBackground'
  | 'fixedJackpotsCityJackpots';

export type TStandardRegionImageKeys =
  | 'diamondPattern'
  | 'jpcRewardsMiniBanner'
  | 'ogImage';

export type TDynamicImageKeys =
  | 'campaign'
  | 'casinoCategoryIconV2'
  | 'casinoProvidersV2'
  | 'casinoProviders'
  | 'bankingIcon'
  | 'bigWinners'
  | 'regBanner'
  | 'partnerBanner'
  | 'progressiveJackpotsTitle'
  | 'progressiveJackpotsSlotMachine'
  | 'progressiveJackpotsBackground'
  | 'partnerStreamingBanner'
  | 'partnerStreamingImage'
  | 'partnerStreamingPartnership'
  | 'howToBanner';

interface ILogoBrandingImages {
  za: Record<'light' | 'dark', string>;
  global: Record<'light' | 'dark', string>;
}

interface IPlaceholderBrandingImages {
  za: Record<TPlaceholderKeys, string>;
  global: Record<TPlaceholderKeys, string>;
}

interface IStandardRegionImages {
  za: Record<TStandardRegionImageKeys, string>;
  global: Record<TStandardRegionImageKeys, string>;
}

export const logos: ILogoBrandingImages = {
  za: {
    light: '/medialibraries/content.jpc.africa/branding/jpccasino_sa_black.svg',
    dark: '/medialibraries/content.jpc.africa/branding/jpccasino_sa_white.svg',
  },
  global: {
    light:
      '/medialibraries/content.jpc.africa/branding/jpccasino_global_black.svg',
    dark: '/medialibraries/content.jpc.africa/branding/jpccasino_global_white.svg',
  },
};

export const placeholders: IPlaceholderBrandingImages = {
  za: {
    winnersMobile: `/medialibraries/Jackpotcity.co.za/content-pages/Winners/BigWinnersPage_MBHomeBanner_720_500.png`,
    winnersDesktop: `/medialibraries/Jackpotcity.co.za/content-pages/Winners/BigWinnersPage_DTLobbyBanner_1600_300.png`,
    winnersPlaceholderMobile: `/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_720_500.png`,
    winnersPlaceholderDesktop: `/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_1600_300.png`,
    marketingPlaceholderMobile: `/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_720_500.png`,
    marketingPlaceholderDesktop: `/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_1600x500.png`,
    sideBannerPlaceholder: `/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_254_524.jpg`,
    promotionsPlaceholder: `/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_388_100.jpg`,
    bannerPlaceholderMobile: `/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_720_200.png`,
    bannerPlaceholderDesktop: `/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_1600_300.png`,
    contentPostPlaceholder: `/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_1600x500.png`,
    contentCardPlaceholder: `/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_500x500.jpg`,
    masonryPlaceholderOne: `/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_720_500.png`,
    masonryPlaceholderTwo: `/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_254x524.jpg`,
    categoryCardPlaceholder: `/medialibraries/content.jpc.africa/branding/jpccasino_sa_placeholder_500x500.jpg`,
    iconPlaceholder:
      '/medialibraries/content.gmgamingsystems.com/Casino-Category-Icons/v2/all.svg',
  },
  global: {
    winnersMobile: `/medialibraries/Jackpotcity.co.za/content-pages/Winners/BigWinnersPage_MBHomeBanner_720_500.png`,
    winnersDesktop: `/medialibraries/Jackpotcity.co.za/content-pages/Winners/BigWinnersPage_DTLobbyBanner_1600_300.png`,
    winnersPlaceholderMobile: `/medialibraries/content.jpc.africa/branding/jpccasino_global_placeholder_720_500.png`,
    winnersPlaceholderDesktop: `/medialibraries/content.jpc.africa/branding/jpccasino_global_placeholder_1600_300.png`,
    marketingPlaceholderMobile: `/medialibraries/content.jpc.africa/branding/jpccasino_global_placeholder_720_500.png`,
    marketingPlaceholderDesktop: `/medialibraries/content.jpc.africa/branding/jpccasino_global_placeholder_1600x500.png`,
    sideBannerPlaceholder: `/medialibraries/content.jpc.africa/branding/jpccasino_global_placeholder_254_524.jpg`,
    promotionsPlaceholder: `/medialibraries/content.jpc.africa/branding/jpccasino_global_placeholder_388_100.jpg`,
    bannerPlaceholderMobile: `/medialibraries/content.jpc.africa/branding/jpccasino_global_placeholder_720_200.png`,
    bannerPlaceholderDesktop: `/medialibraries/content.jpc.africa/branding/jpccasino_global_placeholder_1600_300.png`,
    contentPostPlaceholder: `/medialibraries/content.jpc.africa/branding/jpccasino_global_placeholder_1600x500.png`,
    contentCardPlaceholder: `/medialibraries/content.jpc.africa/branding/jpccasino_global_placeholder_500x500.jpg`,
    masonryPlaceholderOne: `/medialibraries/content.jpc.africa/branding/jpccasino_global_placeholder_720_500.png`,
    masonryPlaceholderTwo: `/medialibraries/content.jpc.africa/branding/jpccasino_global_placeholder_254x524.jpg`,
    categoryCardPlaceholder: `/medialibraries/content.jpc.africa/branding/jpccasino_global_placeholder_500x500.jpg`,
    iconPlaceholder:
      '/medialibraries/content.gmgamingsystems.com/Casino-Category-Icons/v2/all.svg',
  },
};

export const standardImages: Record<TStandardImageKeys, string> = {
  positionGold:
    '/medialibraries/Jackpotcity.co.za/content-pages/Winners/icon-type-gold.svg',
  positionSilver:
    '/medialibraries/Jackpotcity.co.za/content-pages/Winners/icon-type-silver.svg',
  positionBronze:
    '/medialibraries/Jackpotcity.co.za/content-pages/Winners/icon-type-bronze.svg',
  hotGames:
    '/medialibraries/Jackpotcity.co.za/content-pages/Winners/icon-hot-games.svg',
  mostPopular:
    '/medialibraries/Jackpotcity.co.za/content-pages/Winners/icon-most-popular.svg',
  winnersIcon:
    '/medialibraries/Jackpotcity.co.za/content-pages/Winners/icon-winner.svg',
  infoIcon:
    '/medialibraries/Jackpotcity.co.za/content-pages/Winners/icon-info.svg',
  celebrationIcon:
    '/medialibraries/Jackpotcity.co.za/content-pages/Winners/icon-celebration.svg',
  mostLiked:
    '/medialibraries/Jackpotcity.co.za/content-pages/Winners/icon-most-liked.svg',
  notFoundLight:
    '/medialibraries/Jackpotcity.co.za/content-pages/404_light.png',
  notFoundDark: '/medialibraries/Jackpotcity.co.za/content-pages/404_dark.png',
  huawei: '/medialibraries/content.jpc.africa/icons/huawei.svg',
  android: '/medialibraries/content.jpc.africa/icons/android.svg',
  apple: '/medialibraries/content.jpc.africa/icons/apple.svg',
  googlePlay: '/medialibraries/content.jpc.africa/icons/google_play_badge.png',
  exclusive:
    '/medialibraries/content.gmgamingsystems.com/Casino-Games/Game Backgrounds/JPCExclusive.svg',
  mpumalangaEconomicRegulator:
    '/medialibraries/content.gmgamingsystems.com/jackpotcity/branding/mpumalanga-economic-regulator.png',
  freeplayOverlay:
    '/medialibraries/Content.jpc.africa/branding/demo_water_mark.png',
  merLicense:
    '/medialibraries/Jackpotcity.co.za/document/Jackpot_City_Licence_Certificate.pdf',
  dailyWheelPopUp:
    '/medialibraries/content.jpc.africa/branding/jpccasino_dailyspin_notification.png',
  jpcRewardsCityLogo:
    '/medialibraries/Content.jpc.africa/branding/jpccasino_city_rewards.svg',
  progressiveJackpotsPlayNowCta:
    '/medialibraries/Jackpotcity.co.za/content-pages/Stackpot/jpccasino_global_progressive_jackpots_play_now_cta.png',
  progressiveJackpotsMoreInfoCta:
    '/medialibraries/Jackpotcity.co.za/content-pages/Stackpot/jpccasino_global_progressive_jackpots_more_info_cta.png',
  progressiveJackpotsInGameBackground:
    '/medialibraries/Content.jpc.africa/branding/jpccasino_global_progressive_jackpots_ingame_background.png',
  fixedJackpotsCityJackpots:
    '/medialibraries/Jackpotcity.co.za/content-pages/fixed-jackpots/city_jackpots.png',
  myBigWinsShareImage:
    '/medialibraries/Content.jpc.africa/branding/my-big-wins.png',
};

export const standardRegionImages: IStandardRegionImages = {
  za: {
    diamondPattern:
      '/medialibraries/content.jpc.africa/branding/jpccasino_user_message.svg',
    jpcRewardsMiniBanner:
      '/medialibraries/Content.jpc.africa/branding/jpccasino_sa_loyalty_312_120.png',
    ogImage: '/images/jpccasino_og_image.png',
  },
  global: {
    diamondPattern:
      '/medialibraries/content.jpc.africa/branding/jpccasino_global_user_message.svg',
    jpcRewardsMiniBanner:
      '/medialibraries/Content.jpc.africa/branding/jpccasino_global_loyalty_312_120.png',
    ogImage: '/images/jpccasino_global_og_image.png',
  },
};

export const dynamicImages: Record<TDynamicImageKeys, string> = {
  campaign:
    '/medialibraries/content.jpc.africa/content/{size}_{region}_{campaign}.png',
  casinoCategoryIconV2:
    '/medialibraries/content.gmgamingsystems.com/Casino-Category-Icons/v2/{icon}.svg',
  casinoProviders:
    '/medialibraries/content.gmgamingsystems.com/casino-providers/{provider}.png',
  casinoProvidersV2:
    '/medialibraries/content.gmgamingsystems.com/casino-providers/{provider}.svg',
  bankingIcon:
    '/medialibraries/content.gmgamingsystems.com/jackpotcity/banking/{provider}_{theme}.png',
  bigWinners:
    '/medialibraries/content.jpc.africa/big-winners/bigwinners_{platform}_{dimensions}_{locale}_{region}.png',
  regBanner:
    '/medialibraries/content.jpc.africa/content/{size}_{region}_wo_newbcw.png',
  partnerBanner:
    '/medialibraries/content.jpc.africa/content/{size}_{region}_partner_register.png',
  progressiveJackpotsTitle:
    '/medialibraries/Jackpotcity.co.za/content-pages/Stackpot/jpccasino_global_progressive_jackpots_title_{device}.png',
  progressiveJackpotsSlotMachine:
    '/medialibraries/Jackpotcity.co.za/content-pages/Stackpot/jpccasino_global_progressive_jackpots_slot_machine_{device}.png',
  progressiveJackpotsBackground:
    '/medialibraries/Jackpotcity.co.za/content-pages/Stackpot/jpccasino_global_progressive_jackpots_background_{device}.png',
  partnerStreamingBanner:
    '/medialibraries/content.jpc.africa/streamers-academy/streamersacademy_headerimage_{dimensions}.png',
  partnerStreamingImage:
    '/medialibraries/content.jpc.africa/streamers-academy/streamersacademy_image{iteration}_680_470.png',
  partnerStreamingPartnership:
    '/medialibraries/content.jpc.africa/streamers-academy/streamersacademy_partnership{iteration}_186_186.png',
  howToBanner:
    '/medialibraries/content.jpc.africa/how-to/HowTo_BannerImage_{device}.png',
};
